module.exports = __webpack_public_path__ + "img/system.d159ab05.png";